import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { Row, Col } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

import Panel from 'components/Helpers/Panel';

import s from './HowItWorks.css';

const HowItWorks = () => (
  <Row className={s.root}>
    <Col xs="12">
      <Panel>
        <p className={`h3 ${s.heading}`}>
          <FormattedMessage
            id="sell_auto.howitworks.heading"
            defaultMessage="Як це працює"
            description=""
          />
        </p>
        <p className={s.description}>
          <FormattedMessage
            id="sell_auto.howitworks.descr"
            defaultMessage="Розмістіть оголошення та продайте авто швидко за вигідною ціною"
            description=""
          />
        </p>
        <Row>
          <Col xs="12" md="4" className={s.item}>
            <p className={s.item_icon}>1</p>
            <p className={`lead ${s.item_title}`}>
              <FormattedMessage
                id="sell_auto.howitworks.step1"
                defaultMessage="Створіть акаунт"
                description=""
              />
            </p>
            <p>
              <FormattedMessage
                id="sell_auto.howitworks.step1.descr"
                defaultMessage="Вкажіть свій номер телефону та підтвердьте його за допомогою SMS"
                description=""
              />
            </p>
          </Col>
          <Col xs="12" md="4" className={s.item}>
            <p className={s.item_icon}>2</p>
            <p className={`lead ${s.item_title}`}>
              <FormattedMessage
                id="sell_auto.howitworks.step2"
                defaultMessage="Додайте оголошення"
                description=""
              />
            </p>
            <p>
              <FormattedMessage
                id="sell_auto.howitworks.step2.descr"
                defaultMessage="Заповніть дані по автомобілю та завантажте фото"
                description=""
              />
            </p>
          </Col>
          <Col xs="12" md="4" className={s.item}>
            <p className={s.item_icon}>3</p>
            <p className={`lead ${s.item_title}`}>
              <FormattedMessage
                id="sell_auto.howitworks.step3"
                defaultMessage="Продайте авто"
                description=""
              />
            </p>
            <p>
              <FormattedMessage
                id="sell_auto.howitworks.step3.descr"
                defaultMessage="Приймайте дзвінки від реальних покупців"
                description=""
              />
            </p>
          </Col>
        </Row>
      </Panel>
    </Col>
  </Row>
);

export default withStyles(s)(HowItWorks);
